var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPorterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2256_100799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.6367C17.3848 22.6367 21.75 18.2715 21.75 12.8867C21.75 7.50194 17.3848 3.13672 12 3.13672C6.61522 3.13672 2.25 7.50194 2.25 12.8867C2.25 18.2715 6.61522 22.6367 12 22.6367Z",
    fill: "#A1342D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0931 13.9688C12.9431 15.1185 11.0701 15.1185 9.9031 13.9688C8.7531 12.8191 8.7531 10.9457 9.9031 9.77891C11.0541 8.61212 12.9261 8.62919 14.0931 9.77891C15.2591 10.9286 15.2591 12.802 14.0931 13.9688ZM8.4991 8.37312C6.5641 10.3081 6.5641 13.4351 8.4991 15.3553L12.0001 18.8527L15.5001 15.3553C17.4361 13.421 17.4361 10.2933 15.5001 8.37312C13.5661 6.43813 10.4341 6.43813 8.4991 8.37312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2256_100799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.886719)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorterIcon);
export default __webpack_public_path__ + "static/media/porter_icon.456e284c175d7dcfd47ba7f3e1afc2c9.svg";
export { ForwardRef as ReactComponent };